import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "./Loading";
import { useDbUser } from "../contexts/UserContext";

/**
 * A component that protects routes based on whether the user is invited
 * @param {Object} props - Component props
 * @param {Function} props.component - Component to render if authenticated and invited
 * @returns {JSX.Element} - Protected route component
 */
export const InvitedRoute = ({ component, ...args }) => {
  const { user } = useAuth0();
  const { dbUser, isLoading: isDbUserLoading } = useDbUser();

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loading />,
  });

  // Show loading while we're fetching the database user data
  if (isDbUserLoading) {
    return <Loading />;
  }

  // If the user is authenticated but not invited, redirect to waitlist
  if (user && dbUser && !dbUser.invited) {
    return <Navigate to="/waitlist" replace />;
  }

  return <Component {...args} />;
};

export default InvitedRoute;
